import React, { useState } from 'react';
import { AnalysisRange, presetRange, RangePreset } from '../../../hooks/analysis/useAnalysisRange';
import './DateRangePicker.css';

interface DateRangePickerProps {
  value: AnalysisRange;
  onChange: (range: AnalysisRange) => void;
}

const PRESETS: Array<{ id: RangePreset; label: string }> = [
  { id: 'last30', label: 'Last 30 days' },
  { id: 'thisMonth', label: 'This month' },
  { id: 'seasonToDate', label: 'Season to date' },
  { id: 'lastSeason', label: 'Last season' },
  { id: 'thisYear', label: 'This year' },
];

const DateRangePicker: React.FC<DateRangePickerProps> = ({ value, onChange }) => {
  const [draftFrom, setDraftFrom] = useState<string | null>(null);
  const [draftTo, setDraftTo] = useState<string | null>(null);

  const from = draftFrom ?? value.from;
  const to = draftTo ?? value.to;

  const activePreset = PRESETS.find(p => {
    const range = presetRange(p.id);
    return range.from === value.from && range.to === value.to;
  })?.id;

  const commit = (nextFrom: string, nextTo: string) => {
    if (nextFrom && nextTo && nextFrom <= nextTo) {
      onChange({ from: nextFrom, to: nextTo });
      setDraftFrom(null);
      setDraftTo(null);
    }
  };

  return (
    <div className="date-range-picker">
      <div className="date-range-presets">
        {PRESETS.map(preset => (
          <button
            key={preset.id}
            type="button"
            className={`date-range-preset ${activePreset === preset.id ? 'date-range-preset--active' : ''}`}
            onClick={() => onChange(presetRange(preset.id))}
          >
            {preset.label}
          </button>
        ))}
      </div>
      <div className="date-range-inputs">
        <input
          type="date"
          value={from}
          max={to}
          onChange={e => {
            setDraftFrom(e.target.value);
            commit(e.target.value, to);
          }}
        />
        <span className="date-range-sep">to</span>
        <input
          type="date"
          value={to}
          min={from}
          onChange={e => {
            setDraftTo(e.target.value);
            commit(from, e.target.value);
          }}
        />
      </div>
    </div>
  );
};

export default DateRangePicker;
